var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('b-container',[_c('SharePanel',{attrs:{"shares":_vm.shares}})],1):_c('b-container',[_c('b-row',[_c('b-col',[_c('h2',[_vm._v("Loading...")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }